/* eslint-disable react/prop-types */
export const pad = (n) => String(n).padStart(2, "0");

export const fmtTime = (d = new Date()) =>
  d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });

export const dateKey = (d) => d.toISOString().split("T")[0];

export const parseTimeToMinutes = (timeStr) => {
  if (!timeStr) return null;
  const [hours, minutes] = timeStr.split(":").map(Number);
  return hours * 60 + minutes;
};

export const formatMinutesToTime = (minutes) => {
  if (minutes === null || minutes === undefined) return "--";
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;
  return `${pad(displayHours)}:${pad(mins)} ${ampm}`;
};

export const getCurrentMinutes = () => {
  const now = new Date();
  return now.getHours() * 60 + now.getMinutes();
};

export const formatSecondsToTime = (seconds) => {
  if (!seconds) return "00:00:00";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
};

export const formatTimer = (seconds) => {
  const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const s = String(seconds % 60).padStart(2, "0");
  return `${h}:${m}:${s}`;
};

export const getTodayRange = () => {
  const today = new Date();
  const start = new Date(today);
  start.setDate(start.getDate() - 6);
  const end = new Date(today);
  return {
    start: start.toISOString().split("T")[0],
    end: end.toISOString().split("T")[0],
  };
};

export const shiftDateBy = (dateStr, days) => {
  const date = new Date(dateStr);
  date.setDate(date.getDate() + days);
  return date.toISOString().split("T")[0];
};


// timeUtils.js में ये functions add करें

// Get week from date (Monday to Sunday)
export const getWeekFromDate = (date) => {
  const currentDate = new Date(date);
  const currentDay = currentDate.getDay();
  
  // Calculate start of week (Monday)
  const start = new Date(currentDate);
  start.setDate(start.getDate() - (currentDay === 0 ? 6 : currentDay - 1));
  
  // Calculate end of week (Sunday)
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  
  // Reset times to start of day
  start.setHours(0, 0, 0, 0);
  end.setHours(23, 59, 59, 999);
  
  return {
    start: start.toISOString().split('T')[0],
    end: end.toISOString().split('T')[0]
  };
};

// Get all days of a week
export const getWeekDays = (startDate) => {
  const start = new Date(startDate);
  const days = [];
  
  for (let i = 0; i < 7; i++) {
    const date = new Date(start);
    date.setDate(date.getDate() + i);
    days.push(date);
  }
  
  return days;
};

// Get status color based on attendance status
export const getStatusColor = (status) => {
  const colors = {
    'present': '#10B981', // Green
    'absent': '#EF4444', // Red
    'weekend': '#F97316', // Orange
    'holiday': '#FFD700', // Yellow
    'leave': '#8B5CF6', // Purple
    'halfday': 'linear-gradient(90deg, #10B981 50%, #EF4444 50%)', // Half green half red
  };
  
  return colors[status.toLowerCase()] || '#6B7280'; // Default gray
};

// Add this function to your existing timeUtils.js

export const formatDateToAPI = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toISOString().split('T')[0]; // Returns YYYY-MM-DD
};